/**
 * Constants for the CheckoutModal component family (3 variants:
 * physical / service / digital).
 *
 * SPEC-244 · partición VERBATIM de
 * frontend/src/components/market/checkout-modal.tsx (2.637 L).
 */

/**
 * Quantity upper bound for the physical modal's selector — 10. The backend
 * Zod schema allows up to 1000 (`orderCreateSchema.quantity.max(1000)`) for
 * bulk/wholesale scenarios, but the modal UI caps at 10 per SPEC-081
 * Fase 4 §6.1 (the typical buyer purchases 1-2 units; bulk buyers should
 * contact the seller directly).
 *
 * §6 Anti-Invención: the 1-10 range comes from SPEC-081 Fase 4 §6.1
 * ("Quantity selector (1-10)") — NOT invented.
 */
export const MAX_QUANTITY = 10;

/**
 * Service deposit percent baseline per SPEC-NEGOCIO §10.7 — used ONLY
 * when `product.serviceConfig.depositPercent` is missing (should never
 * happen — Fase 3 pre-validate hook requires `serviceConfig` for
 * `type='service'` products, and the depositPercent field defaults to 50
 * server-side). This is a defense-in-depth fallback.
 */
export const SERVICE_DEPOSIT_PERCENT_FALLBACK = 50;
